import React from "react";
import CountUp from "react-countup";
import BannerBg from "../../../assets/images/shapes/shape-02.png";
import AboutUs from "../../../assets/images/resource/about-us.png";
import shape1 from "../../../assets/images/shapes/shape-01.png";
import partner from "../../../assets/images/cloudera-partner-badge.jpg";
import JourneyTimeline from "../../JourneyTimeline";
import "../../JourneyTimeline.css";

const AboutTwo = () => {
  return (
    <section className="about__section p_relative pt-4">
      <div className="pattern-layer">
        {/* <div
          className="pattern-2 p_absolute"
          data-parallax='{"x": -50}'
          style={{ backgroundImage: `url(${BannerBg})` }}
        ></div> */}
      </div>
      {/* <div className="boild__text">
        <h1>Smart iLab Works</h1>
      </div> */}
      <div className="auto-container">
        <div className="row">
          {/* <div className="col-lg-6 col-md-12">
            <div className="about__block p_relative">
              <figure
                className="wow zoomIn animated"
                data-wow-delay="100ms"
                data-wow-duration="1500ms"
              >
                <img src={AboutUs} alt="" />
              </figure>
              <div
                className="funfact__content about"
                style={{ backgroundImage: `url(${shape1})` }}
              >
                <div className="count-outer count-box">
                  <h1 className="count-text">
                    <CountUp start={0} end={10} />
                    <span>K+</span>
                  </h1>
                </div>
                <p>World wide Client</p>
              </div>
            </div>
          </div> */}
          <div className="col-lg-1"></div>
          <div className="col-lg-12 col-md-12">
            <div className="about__text__block">
              <div className="sub__title">
                <h4 style={{ color: "#009999" }}>About Us</h4>
              </div>
              <div className="title two about">
                <h2
                  style={{
                    color: "#009999",
                    padding: "10px 0",
                  }}
                >
                  Welcome to Smart iLab Works - Empowering Your Business with AI
                  and RPA Solutions
                </h2>
              </div>

              <div className="texts">
                <p style={{ textAlign: "justify" }}>
                  At Smart iLab Works, we're pioneering the future of
                  data-driven decision-making through cutting-edge artificial
                  intelligence solutions. Our mission is to empower businesses
                  of all sizes to harness the power of data to drive innovation,
                  efficiency, and growth.
                </p>

                <section
                  className="title two"
                  style={{
                    backgroundcolor: "#009999",
                    textalign: "center",
                  }}
                >
                  <h4
                    style={{
                      padding: "10px 0",
                    }}
                  >
                    Who We Are
                  </h4>
                  <p style={{ textAlign: "justify" }}>
                    We are a team of passionate data scientists, AI engineers,
                    and business strategists dedicated to delivering tailor-made
                    AI and RPA solutions that address our clients' unique
                    challenges. With a deep understanding of both technology and
                    business domains, we're committed to unlocking the full
                    potential of data to transform industries.
                  </p>
                </section>
                <section
                  className="title two"
                  style={{
                    backgroundcolor: "#009999",
                    textalign: "center",
                  }}
                >
                  <h4
                    style={{
                      padding: "10px 0",
                    }}
                  >
                    What we do
                  </h4>

                  <ul className="what-we-do-ul">
                    <li className="what-we-do">
                      <strong>AI and RPA Consulting:</strong> We provide expert
                      guidance and consulting services to help businesses
                      integrate AI & RPA into their operations effectively.
                    </li>
                    <li className="what-we-do">
                      <strong>Data Analytics:</strong> Set up big data clusters
                      on-premises and in the cloud, and design, build, deploy,
                      and maintain end-to-end data pipelines for enterprise data
                      lakes.
                    </li>
                    <li className="what-we-do">
                      <strong>Web Development:</strong> We deliver robust,
                      secure, and scalable web solutions aligned with
                      organizational objectives.
                    </li>
                    <li className="what-we-do">
                      <strong>Digital Consulting:</strong> Our digital
                      consulting services provide strategic guidance on
                      technology adoption, system optimization, and user-centric
                      design to enhance operational efficiency and support
                      sustainable business growth.
                    </li>
                    <li className="what-we-do">
                      <strong>AI Training and Workshops:</strong> We offer
                      training programs and workshops to equip businesses and
                      professionals with the skills needed to leverage AI
                      technologies effectively.
                    </li>
                  </ul>
                </section>
                {/* <section
                    className="title two"
                    style={{
                      backgroundcolor: "#009999",
                      textalign: "center",
                    }}
                  >
                    <h2
                      style={{
                        color: "#000",
                        fontWeight: 500,
                      fontSize:"30px",
                      }}
                    >
                      Our Impact
                    </h2>
                    <p style={{ textAlign: "justify" }}>
                      Our solutions have helped numerous organizations across
                      various industries unlock new opportunities, optimize
                      processes, and achieve measurable results. Whether it's
                      improving customer experience, streamlining operations, or
                      enhancing product performance, we're committed to driving
                      tangible outcomes for our clients.
                    </p>
                  </section> */}
                {/* 
                  <section
                    className="title two"
                    style={{
                      backgroundcolor: "#009999",
                      textalign: "center",
                    }}
                  >
                    <h2
                      style={{
                        color: "#000",
                        fontWeight: 500,
                      fontSize:"30px",
                      }}
                    >
                      Collaborate with Us
                    </h2>
                    <p style={{ textAlign: "justify" }}>
                      Are you ready to embark on a trans-formative AI and RPA
                      journey? Whether you're a startup looking to innovate or
                      an established enterprise seeking to stay ahead of the
                      curve, we're here to support you every step of the way.
                      Let's collaborate to unlock the full potential of AI and
                      RPA for your business.{" "}
                    </p>
                  </section> */}
                <section
                  className="title two"
                  style={{
                    backgroundcolor: "#009999",
                    textalign: "center",
                  }}
                >
                  <h4
                    style={{
                      padding: "10px 0",
                    }}
                  >
                    Our Trusted Partnerships
                  </h4>
                  <p style={{ textAlign: "justify" }}>
                    At SIW, we collaborate with leading technology partners to
                    deliver cutting-edge data solutions. As a proud{" "}
                    <strong>Cloudera Partner Network Member</strong>, we
                    leverage the Cloudera Data Platform to provide secure,
                    scalable, and enterprise-grade data engineering and
                    analytics solutions.
                  </p>
                  <a
                    href="https://www.cloudera.com/partners.html"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <img
                      src={partner}
                      alt="Cloudera Partner Network Member"
                      style={{
                        maxHeight: "100px",
                        marginTop: "30px",
                      }}
                    />
                  </a>
                </section>
                <br />

                <div>
                  <JourneyTimeline />
                </div>
               
                <h4
                  className="about-two-h4"
                  style={{ padding: "20px 0px 50px" }}
                >
                  {/* <br /> */}
                  <strong style={{ color: "#009999" }}>At SiW</strong>, we don’t
                  just offer solutions—we become your trusted technology
                  partner, delivering innovation with precision. Let’s shape the
                  future together.
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutTwo;
